function fetchAwardQuery (rootQueryType, id, pageSize, page, sortField, sortOrder, filter) {
  rootQueryType = ['organisationalUnit', 'person'].includes(rootQueryType) ? rootQueryType : null
  id = rootQueryType === 'organisationalUnit' ? Number(id) : `${id}`

  // if the rootQueryType does not match for organisational unit or person then return nulls
  if (!rootQueryType) {
    return null
  }

  let variables = {
    id: id || null,
    pageSize: Number(pageSize) || 20,
    page: Number(page) || 1
  }

  if (sortOrder) {
    variables['sortOrder'] = sortOrder
  }

  if (sortField) {
    variables['sortField'] = sortField
  }

  if (filter && filter.typeIds) {
    if (filter.typeIds.startsWith('PREIS_')) {
      let id = filter.typeIds.slice('PREIS_'.length)
      variables['filterTypeIds'] = [Number(id)]
    } else if (filter.typeIds === 'WEITERE_PREISE') {
      variables['filterTypeIds'] = [
        1, 5, 6, 7, 8, 9, 10, 11, 12, 13,
        14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
        24, 25, 26, 27, 28
      ]
    }
  }

  if (filter && filter.year && Number(filter.year)) {
    variables['filterYear'] = Number(filter.year)
  }

  if (filter && filter.freetext && filter.freetext.length > 0) {
    variables['filterFreetext'] = filter.freetext
  }

  if (filter && filter.person && filter.person.length > 0) {
    variables['filterPerson'] = filter.person
  }

  return {
    operationName: 'fetchAwardQuery',
    query: `
      query fetchAwardQuery(
        $id: ID!,
        $pageSize:Int!,
        $page:Int!,
        $sortOrder:SortOrder,
        $sortField:AwardSortKeys,
        $filterYear:Int,
        $filterTypeIds:[Int],
        $filterFreetext:String,
        $filterPerson:String,
      ) {
        ${rootQueryType}(id: $id) {
          preis:awards(
            pageSize: $pageSize,
            page: $page,
            sortOrder: $sortOrder,
            orderBy:$sortField,
            filter: {
              year: $filterYear,
              freeText: $filterFreetext,
              person: $filterPerson,
              typeIds: $filterTypeIds,
            }
          ) {
            meta {
              pageNumber
              pageSize
              totalEntries
              totalPages
            }
            entries {
              ... on Award {
                _entityName
                _id:id
                html {
                  de
                  en
                }
              }
            }
          }
        }
      }
    `,
    variables
  }
}

export { fetchAwardQuery }



// WEBPACK FOOTER //
// ./src/graphql/award.js